// Shared client-side state for the multi-step assessment flow.
import { createContext, useContext, useMemo, useState } from "react";

const AssessmentCtx = createContext(null);

const initial = {
  programSlug: null,
  // ---- Phase B canonical compound + stage selection ----
  selectedCompoundId: null,
  selectedCompoundSlug: null,
  selectedStage: null,
  // ---- Legacy aliases (kept one release for safety; new consultation
  // submissions no longer send these to the BE). ----
  selectedProtocolTier: null,
  selectedProductId: null,
  selectedProtocol: null,
  monthlyPrice: null,
  questionnaire: {
    sex: "",
    dateOfBirth: "",
    heightCm: "",
    weightKg: "",
    bmi: "",
    healthGoals: [],
    medicalConditions: [],
    currentMedications: "",
    allergies: "",
    previousExperience: "",
    pregnancyStatus: "",
    additionalNotes: "",
  },
  shippingAddress: { line1: "", line2: "", city: "", state: "", zip: "" },
  consultPaymentIntentId: null,
};

export function AssessmentProvider({ children }) {
  const [data, setData] = useState(initial);

  const update = (patch) => setData((prev) => ({ ...prev, ...patch }));
  const updateQ = (patch) =>
    setData((prev) => ({ ...prev, questionnaire: { ...prev.questionnaire, ...patch } }));
  const updateAddr = (patch) =>
    setData((prev) => ({ ...prev, shippingAddress: { ...prev.shippingAddress, ...patch } }));
  const reset = () => setData(initial);

  const value = useMemo(() => ({ data, update, updateQ, updateAddr, reset }), [data]);
  return <AssessmentCtx.Provider value={value}>{children}</AssessmentCtx.Provider>;
}

export function useAssessment() {
  const ctx = useContext(AssessmentCtx);
  if (!ctx) throw new Error("useAssessment must be used inside AssessmentProvider");
  return ctx;
}
